import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { properties } from '@env/properties.config';
import { Base64 } from '@app/shared/services/base64.service';
import { ModalAlertService } from '@app/shared/services/modal-alert.service';
import { Messages } from '@app/shared/enums/messages.enums';
import { environment } from '@env/environment';

@Component({
  selector: 'app-image-loader',
  templateUrl: './image-loader.component.html',
  styleUrls: ['./image-loader.component.scss']
})
export class ImageLoaderComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;

  @Input() defaultImage: string;
  @Input() ServerPath: string;
  @Output() imageLoaded: EventEmitter<any> = new EventEmitter<any>();

  imageVisible = false;
  image: HTMLImageElement = new Image();

  constructor(private modalAlertService: ModalAlertService) { }

  ngOnInit() {
    this.image.src = this.getImage(this.defaultImage, this.ServerPath, properties.defaultUserImage);
  }

  openFileDialog(): void {
    const event = new MouseEvent('click', { bubbles: false });
    this.fileInput.nativeElement.dispatchEvent(event);
  }

  loadImageFile(eventFile: any): void {
    const fileReader = new FileReader();
    const file = eventFile.target.files[0];

    fileReader.onload = (event: any) => {
      const imageType = file.type;

      if (!this.isValidImageType(imageType)) {
        this.modalAlertService.showAlert({
          width: '400px',
          data: { error: Messages.InvalidImageType }
        });
        return;
      }

      /*
      * 5 mb
       */
      if (file.size > 5e+6) {
        this.modalAlertService.showAlert({
          width: '400px',
          data: { error: Messages.invalidImageSize }
        });
        return;
      }
      this.loadBase64Image(event.target.result, file);
    };
    fileReader.readAsDataURL(file);
  }


  loadBase64Image(imageBase64: string, file: File): void {
    this.image = new Image();
    this.image.src = imageBase64;
    this.imageLoaded.emit({
      file: file,
      imageBase64: imageBase64
    });
  }

  getImage(image: string, imgServer: string, defaultImg: string): string {
    return Base64.getPathFromFileNameOrBase64(image, imgServer, defaultImg);
  }

  isValidImageType(type: string): boolean {
    return properties.imageExtension.includes(type);
  }
}
